/**
 * Export Template API
 *
 * Saved export definitions (columns + filters + format) so a recurring report
 * can be re-run without rebuilding it each time.
 *
 * Backend: apps/backend/src/domains/works-lite/shared/export/templateRoutes.ts
 */

import { apiClient } from '@/lib/api';

export interface ExportTemplate {
  id: number;
  name: string;
  description: string | null;
  export_type: string;
  format: 'csv' | 'xlsx';
  fields: string[];
  filters: unknown;
  is_shared: boolean;
  user_id: number;
  username: string | null;
  created_at: string;
  updated_at: string | null;
}

export interface CreateExportTemplateInput {
  name: string;
  description?: string;
  export_type: string;
  format: 'csv' | 'xlsx';
  fields: string[];
  filters?: unknown;
  is_shared?: boolean;
}

const BASE = '/works-lite/export-templates';

/** Templates visible to the current user: their own, plus any shared ones. */
export async function getExportTemplates(exportType = 'job_list'): Promise<ExportTemplate[]> {
  const response = await apiClient.get<{ data: ExportTemplate[] }>(
    `${BASE}?export_type=${encodeURIComponent(exportType)}`,
  );
  return response.data;
}

export async function createExportTemplate(
  input: CreateExportTemplateInput,
): Promise<ExportTemplate> {
  return apiClient.post<ExportTemplate>(BASE, input);
}

export async function deleteExportTemplate(id: number): Promise<void> {
  await apiClient.delete<void>(`${BASE}/${id}`);
}
